import { Navigate } from 'react-router-dom';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_REWARDS } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const Rewards = () => {
  const { generateSportContextPath } = useSportContext();
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_REWARDS, {
        params: {
          fixture: 'ongoing',
          eventType: So5FixtureEvent.CLASSIC.toLowerCase(),
        },
      })}
      replace
    />
  );
};

export default Rewards;
